// extracted by mini-css-extract-plugin
module.exports = {"main":"styles_main__3sJOE","octicon":"styles_octicon__1VqCT"};